module.exports = __webpack_public_path__ + "img/film_and_music.66fd9800.png";